<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-row :gutter="4" class="h100 configurationList">
            <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']"
                    v-loading="showList && treeLoading">
                <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                     @click="showList = !showList"></div>
                <el-menu class="h100 metadataTree" :default-active="searchForm.basicDataId" @select="selectMenu">
                    <el-menu-item :index="item.basicDataId" v-for="item in basicDataList" :key="item.basicDataId">
                        <span slot="title">{{ item.basicDataName }}</span>
                    </el-menu-item>
                </el-menu>
            </el-col>
            <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
                <div class="el-table-container">
                    <el-form size="small" class="query-form" ref="form" :model="searchForm" inline
                             label-width="100px" @keyup.enter.native="refreshList(1)">
                        <el-form-item prop="keyword" label="关键字：">
                            <el-input v-model.trim="searchForm.keyword" maxlength="20"
                                      placeholder="请输入关键字(限20字)"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="refreshList(1)" size="small">查询
                            </el-button>
                            <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                        </el-form-item>
                        <el-form-item class="f_r">
                            <el-button type="primary" @click="confirm()" size="small">选择藏品</el-button>
                        </el-form-item>
                    </el-form>
                    <!--                    <div class="tips">-->
                    <!--                        <el-link class="el-icon-info" type="primary" :underline="false"></el-link>-->
                    <!--                        已选择{{ dataListSelections.length }}项数据-->
                    <!--                    </div>-->
                    <el-table
                            :data="dataList"
                            size="small" height="100%"
                            class="table" ref="multipleTable" border
                            @selection-change="selectionChangeHandle" row-key='dataId'
                            v-loading="loading">
                        <el-table-column type="selection" :reserve-selection='true' fixed
                                         :selectable="checkSelectable"/>
                        <el-table-column prop="ziyuanbianhaohgzsoegezc" label="资源编号" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="mingcheng" label="资源名称" show-overflow-tooltip></el-table-column>
                        <el-table-column v-if="configId != '1879352716032077826'" prop="warehouseName" label="库房名称" show-overflow-tooltip></el-table-column>
                        <el-table-column v-if="configId != '1879352716032077826'" prop="shelfName" label="所在位置" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="kucunzhuangtaicfqvrvqdye" label="状态" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column fixed="right" min-width="100px" label="操作">
                            <template slot-scope="{row}">
                                <el-button type="text" size="small" @click="detail(row)">详情</el-button>
                                <el-button type="text" size="small" @click="confirm(row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                                @pagination="refreshList"/>
                </div>
            </el-col>
        </el-row>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="confirm()" v-noMoreClick>确定</el-button>
        </div>
        <resource-add-edit-form ref="resourceAddEditForm"></resource-add-edit-form>
    </el-dialog>
</template>

<script>
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";

export default {
    name: "selectColl",
    components: {ResourceAddEditForm},
    data() {
        return {
            title: '选择藏品',
            visible: false,
            selectedId: [], //关联数据已选数据
            treeLoading: false,
            showList: true,
            basicDataList: [],
            searchForm: {
                keyword: '',
                basicDataId: '',
                current: 1,
                size: 20,
            },
            loading: false,
            dataList: [],
            dataListSelections: [],
            total: 0,
            configId: '',
        }
    },
    methods: {
        //selectedId选中的数据
        init(configId, selectedId) {
            this.visible = true
            this.selectedId = selectedId || []
            this.configId = configId
            this.dataListSelections = []
            this.basicDataList = []
            this.$nextTick(() => {
                this.$refs.multipleTable.clearSelection()
                this.getField()
            })
        },

        // 获取元数据模板
        getField() {
            this.treeLoading = true
            this.$axios(this.api.metadata.metadatatableconfigGetById + '?configId=' + this.configId + '&metadataFonctionsModelId=', [], 'post').then(data => {
                if (data.status) {
                    this.basicDataList = data.data.basicDataIdList
                    this.selectMenu(this.basicDataList[0].basicDataId)
                } else {
                    this.$message.error('查询失败')
                }
                this.treeLoading = false
            })
        },

        // 选择树节点
        selectMenu(val) {
            this.searchForm.basicDataId = val
            this.reset(1)
        },

        // 重置
        reset(type) {
            this.searchForm.keyword = ''
            if (!type) {
                this.$refs.multipleTable.clearSelection()
            }
            this.refreshList(1, 3)
        },

        // 获取数据列表 current: 1第一页；searchType：2结果中查询，3高级查询
        refreshList(current) {
            if (current == 1) {
                this.searchForm.current = 1
            }
            this.loading = true
            this.$axios(this.api.collection.outWarehouseSelect, {
                ...this.searchForm,
                metadataTableConfigId:this.configId,
            }, 'get').then(data => {
                if (data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.$nextTick(() => {
                        this.selectedId.map(v => {
                            this.dataList.map(item => {
                                if (v == item.dataId) {
                                    this.$set(item, 'checked', true)
                                }
                            })
                        })
                    })
                    this.loading = false
                } else {
                    this.$message.error('查询失败');
                }
            })
        },

        checkSelectable(row) {
            return !row.checked
        },
        // 确定
        confirm(row) {
            let list = row ? [row.id] : this.dataListSelections
            this.loading = true
            this.$axios(this.api.metadata.groupByTemplate + "?configId=" + this.configId, list, 'post').then(data => {
                    if (data.status) {
                        this.visible = false
                        this.$emit('refreshAssociatedData', {
                            basicDataIdList: data.data.basicDataIdList,
                            selId: list
                        })
                    } else {
                        this.$message.error('操作失败');
                    }
                    this.loading = false
                }
            )
        },

        // 多选
        selectionChangeHandle(val) {
            let ids = val.map(item => {
                return item.dataId
            })
            this.dataListSelections = this.selectedId.concat(ids)
        },

        //资源详情
        detail(row) {
            this.$refs.resourceAddEditForm.init('view', row.id, '', row.basicDataId, '', row)
        },
    }
}
</script>

<style scoped>

</style>
